<template>
  <div
    v-show="isShow && !openSubtitle"
    class="editorBtn"
    :style="{
      'margin-left': TOOL.fixLeft + 'px',
      width: TOOL.clientWidth + 'px',
    }"
  >
    <div class="main">
      <el-tooltip
        effect="dark"
        content="撤销"
        placement="bottom"
        :open-delay="1000"
      >
        <div
          class="undo"
          :class="{ disabled: !canUseBtns.undo }"
          @click="UndoRedo('undo')"
          @mouseenter="onME($event)"
          @mouseleave="onML($event)"
        >
          <i
            class="icon-editor-undo"
            :class="{ disabled: !canUseBtns.undo }"
          ></i>
        </div>
      </el-tooltip>
      <el-tooltip
        effect="dark"
        content="返回"
        placement="bottom"
        :open-delay="1000"
      >
        <div
          class="redo"
          :class="{ disabled: !canUseBtns.redo }"
          @click="UndoRedo('redo')"
          @mouseenter="onME($event)"
          @mouseleave="onML($event)"
        >
          <i
            class="icon-editor-redo"
            :class="{ disabled: !canUseBtns.redo }"
          ></i>
        </div>
      </el-tooltip>
      <el-tooltip
        effect="dark"
        content="图层"
        placement="top"
        :open-delay="1000"
      >
        <!-- @click="onClickLayerBtn($event)" -->
        <div
          class="layer"
          @mouseenter="
            onME($event);
            $analysis({
              category: 'editor_layer',
              action: 'click_layer',
              label: '编辑器_图层',
            });
          "
          @mouseleave="onML($event)"
        >
          <i class="icon-editor-layer"></i>
          <layer-options ref="layerOptionsRef"></layer-options>
        </div>
      </el-tooltip>
      <el-tooltip
        effect="dark"
        content="网格线"
        placement="bottom"
        :open-delay="1000"
      >
        <div
          class="gridlines"
          @click="btnTypeFs('gridlines')"
          :style="{
            background: btnType === 'gridlines' ? '#9692A9' : '#fafaff',
          }"
          :data-is-on="btnType === 'gridlines' ? 1 : 0"
          @mouseenter="onME($event)"
          @mouseleave="onML($event)"
        >
          <i
            class="icon-editor-gridlines"
            :class="{ active: btnType === 'gridlines' }"
          ></i>
        </div>
      </el-tooltip>
      <el-tooltip
        effect="dark"
        content="吸附对齐"
        placement="bottom"
        :open-delay="1000"
      >
        <div
          @click="
            TOOL.adsorb = !TOOL.adsorb;
            $analysis(BaiduAnalysis[TOOL.adsorb ? 'adsorb' : 'adsorbNo']);
          "
          :style="{ background: TOOL.adsorb ? '#9692A9' : '#fafaff' }"
          :data-is-on="TOOL.adsorb ? 1 : 0"
          @mouseenter="onME($event)"
          @mouseleave="onML($event)"
        >
          <i class="icon-editor-adsorb" :class="{ active: TOOL.adsorb }"></i>
        </div>
      </el-tooltip>
      <formatBrush />
      <el-tooltip
        effect="dark"
        content="添加录音"
        placement="bottom"
        :open-delay="1000"
      >
        <div
          class="voice"
          @click="updateUserMsg($event)"
          v-analysis="BaiduAnalysis['sound']"
          @mouseenter="onME($event)"
          @mouseleave="onML($event)"
        >
          <i class="icon-editor-voice"></i>
        </div>
      </el-tooltip>

      <el-tooltip
        effect="dark"
        content="镜头"
        placement="bottom"
        :open-delay="1000"
      >
        <div
          class="adsorb"
          @click="openCameraSet()"
          :style="{ background: lensEditState ? '#9692A9' : '#fafaff' }"
          :data-is-on="lensEditState ? 1 : 0"
          @mouseenter="onME($event)"
          @mouseleave="onML($event)"
        >
          <i class="icon-editor-camera" :class="{ active: lensEditState }"></i>
        </div>
      </el-tooltip>
      <el-tooltip
        effect="dark"
        content="趣味绘图"
        placement="bottom"
        :open-delay="1000"
      >
        <div
          class="hand"
          v-analysis="BaiduAnalysis['autodraw']"
          @click="actionDraw()"
          @mouseenter="onME($event)"
          @mouseleave="onML($event)"
        >
          <i class="icon-editor-paint"></i>
        </div>
      </el-tooltip>
      <el-tooltip
        effect="dark"
        content="文字云"
        placement="bottom"
        :open-delay="1000"
      >
        <div
          class="adsorb"
          :style="{
            background: TopnavMsg.isShowWordCloudDialog ? '#9692A9' : '#fafaff',
          }"
          :data-is-on="TopnavMsg.isShowWordCloudDialog ? 1 : 0"
          @mouseenter="onME($event)"
          @mouseleave="onML($event)"
          @click="openWordCloud()"
          ref="wordCloudBtn"
        >
          <i
            class="icon-editor-wordcloud"
            :class="{ active: TopnavMsg.isShowWordCloudDialog }"
          ></i>
        </div>
      </el-tooltip>

      <el-tooltip
        effect="dark"
        content="导入PPT"
        placement="bottom"
        :open-delay="1000"
      >
        <div
          class="adsorb"
          @click="importPPT()"
          @mouseenter="onME($event)"
          @mouseleave="onML($event)"
        >
          <i class="icon-editor-ppt"></i>
        </div>
      </el-tooltip>

      <div
        class="toggleSize"
        :style="{ background: '#fafaff' }"
        style="width: 78px"
        :data-is-on="btnType === 'gridlines' ? 1 : 0"
      >
        <span class="sizeType" v-if="TOOL.optimized == 'Horizontal'">
          <i>
            <i style="width: 17px; height: 12px"></i>
          </i>
          <font>16:9</font>
        </span>

        <span class="sizeType" v-if="TOOL.optimized == 'Vertical'">
          <i>
            <i style="width: 11px; height: 16px"></i>
          </i>
          <font>9:16</font>
        </span>

        <div class="sizeBox">
          <div>
            <div
              @click="toggleSizeFs(0)"
              :style="{
                background:
                  TOOL.optimized == 'Horizontal' ? '#d4d4e7' : '#f0f0f8',
              }"
              v-analysis="BaiduAnalysis['size16x9']"
            >
              <div>
                <span class="sizeType">
                  <i>
                    <i style="width: 17px; height: 12px"></i>
                  </i>
                  <font>16:9</font>
                </span>
              </div>
            </div>

            <div
              @click="toggleSizeFs(2)"
              :style="{
                background:
                  TOOL.optimized == 'Vertical' ? '#d4d4e7' : '#f0f0f8',
              }"
              v-analysis="BaiduAnalysis['size9x16']"
            >
              <div>
                <span class="sizeType">
                  <i>
                    <i style="width: 11px; height: 16px"></i>
                  </i>
                  <font>9:16</font>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="side" v-show="!openSubtitle">
      <div class="btn-sound" @click="openSubtitleLayer">
        <i class="iconfont iconzimuhepeile"></i>
        声音与字幕
        <div class="msg" v-show="isShowNewSoundMsg">
          声音功能全新升级！可以到“声音与字幕”面板中进行配音、配乐添加和设置啦！
        </div>
      </div>
    </div>

    <!-- <el-tooltip effect="dark" content="查看VIP素材清单" placement="top" :open-delay="1000">
    <div
      class="spriteVipList"
      v-if="this.IsVipSprites.dataLength || UserEquity.isEchart"
      @click="delVip()"
      :style="{
        left: TOOL.fixLeft + TOOL.clientWidth - 74 +'px',
      }"
    >
      VIP素材
    </div>
    </el-tooltip>-->

    <!--<span class="vipWarry" v-if="this.IsVipSprites.dataLength || UserEquity.isEchart">
      您使用了（高级）VIP功能或资源，若您需要导出视频还请
      <a href="/payment?levelType=2" target="_blank"><span @click="popupsbox()">升级会员</span></a>.
    </span>-->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Analysis from "../mixins/analysis/materialBu";
import layerOptions from "./editorBtn/layerOptions";
import formatBrush from "./editorBtn/formatBrush"; // 格式刷
import ImportPPT from "../mixins/importPPT";
export default {
  mixins: [Analysis, ImportPPT],
  components: {
    layerOptions,
    formatBrush,
  },
  data() {
    return {
      isShow: true,
      btnType: false,
      gridlines: null, // 网格线
      toolMask: null, // 工具遮罩
      canUseBtns: {
        undo: false,
        redo: false,
      },
      isShowNewSoundMsg: false,
    };
  },
  watch: {
    TOOL: function (val, oldval) {
      if (this.TOOL) {
        // 网格线
        this.gridlines = "gridlines_tool_handle_box";
        this.gridlines = $("<div></div>")
          .attr({
            id: this.gridlines,
          })
          .css({
            position: "absolute",
            top: "0px",
            left: "0px",
            display: "flex",
            "flex-wrap": "wrap",
            width: this.TOOL.clientWidth + "px",
            height: this.TOOL.clientHeight + "px",
            "z-index": 10,
            opacity: 0,
            "box-sizing": "border-box",
          })
          .appendTo(this.TOOL.handle);

        this.toolMask = "toolMask_" + uuid.generate(); // 工具遮罩
        this.toolMask = $("<div></div>")
          .attr({
            id: this.toolMask,
          })
          .css({
            position: "absolute",
            top: -this.TOOL.fixTop + "px",
            left: -this.TOOL.fixLeft + "px",
            display: "flex",
            "flex-wrap": "wrap",
            width: this.TOOL.option.width + "px",
            height: this.TOOL.option.height + "px",
            "z-index": 5,
            opacity: 0.7,
            "border-style": "solid",
            "border-color": "rgb(241, 241, 248)",
            "border-width": this.TOOL.fixTop + "px " + this.TOOL.fixLeft + "px",
            "box-sizing": "border-box",
          })
          .appendTo(this.TOOL.handle);
        this.operateGridlines(3);
      }
    },
    "TOOL.clientWidth": function (val, oldval) {
      this.gridlines && !this.openSubtitle && this.operateGridlines(2);
    },
    "TOOL.option.width": function (val, oldval) {
      this.toolMaskFs();
    },
    "TOOL.option.height": function (val, oldval) {
      this.toolMaskFs();
    },
    "TOOL.selectedSprite": {
      handler(val, oldval) {
        if (val && val.length === 1) {
          this.toggleLayerOptions(true);
        } else {
          this.toggleLayerOptions(false);
        }
        if (val && val.length > 1) {
          for (let i = 0; i < val.length; i++) {
            // val[i].helpEle.hide(); // 多选复制之后无法选中之前元素的bug
          }
        } else if (oldval && oldval.length > 1) {
          for (let i = 0; i < oldval.length; i++) {
            oldval[i].helpEle.show();
          }
        }
      },
    },
    shortcutType: function (val, oldval) {
      if (this.shortcutType === "freePathEdit") {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    },
    isShowNewSoundMsg(val) {
      if (val && localStorage.getItem("hasUseSubtitle")) {
        this.isShowNewSoundMsg = false;
      }
    },
    openSubtitle(val, old) {
      let isGridOn = this.btnType;
      if (old && !val) {
        setTimeout(() => {
          this.gridlines && this.operateGridlines(2);
          isGridOn && this.operateGridlines(1);
        });
      }
      if (val) {
        this.operateGridlines(0);
      }
    },
  },
  computed: {
    ...mapGetters([
      "TOOL",
      "TopNav_Size",
      "Tool_Size",
      "MaterialPane_Size",
      "IsVipSprites",
      "UserEquity",
      "lensEditState",
      "SelectScenes_Msg",
      "TopnavMsg",
      "shortcutType",
      "ToolScroll_Size",
    ]),
    ...mapGetters({
      openSubtitle: "subtitle/openSubtitle",
    }),
  },
  created() {
    this.$bus.on("checkUndoButton", ({ canUndo, canRedo } = {}) => {
      this.canUseBtns.undo = canUndo;
      this.canUseBtns.redo = canRedo;
    });
    this.$bus.on("showNewSoundMsg", this.showNewSoundMsg);
  },
  beforeDestroy() {
    this.$bus.off("showNewSoundMsg", this.showNewSoundMsg);
  },
  mounted() {},
  methods: {
    showNewSoundMsg(flag) {
      this.isShowNewSoundMsg = flag;
      if (flag) {
        clearTimeout(this.tid);
        this.tid = setTimeout(() => {
          this.isShowNewSoundMsg = false;
        }, 5000);
      }
    },
    btnTypeFs(data) {
      // 按钮状态
      // console.log(this.btnType, data)
      if (this.btnType) {
        this.btnType = false;
        switch (data) {
          case "gridlines": // 关闭盒子
            this.operateGridlines(0);
            this.materialPushAnalysis({ type: "gridlines" });

            break;
        }
      } else if (data) {
        this.btnType = data;
        switch (data) {
          case "gridlines": // 打开盒子
            this.operateGridlines(1);
            this.materialPushAnalysis({ type: "gridlines1" });

            break;
        }
      }
    },
    operateGridlines(data) {
      // 网格线的操作使用
      switch (data) {
        case 0: // 关闭盒子
          this.gridlines.css("opacity", 0);
          break;
        case 1: // 打开盒子
          this.gridlines.css("opacity", 1);
          break;
        case 2: // 重置格子大小
          let size = {
            width: this.TOOL.clientWidth,
            height: this.TOOL.clientHeight,
          };
          this.gridlines.css({
            width: size.width,
            height: size.height,
          });
          this.gridlines
            .find(".patch_grid_width_center_grey_line, .patch_grid_grey_line")
            .css({
              width: size.width / 16,
              height: size.height / 9,
            });
          this.gridlines.find(".patch_center_grid_grey_line").css({
            width: size.width,
          });
          break;
        case 3: // 生成格子并添加到网格线中--左--上
          this.gridlines.empty();
          var width = this.TOOL.clientWidth / 16,
            height = this.TOOL.clientHeight / 9;

          for (var i = 0; i < 9; i++) {
            if (i === 0) {
              for (var z = 0; z < 16; z++) {
                if (z === 8) {
                  $("<div>" + (z + 1) + "</div>")
                    .attr({
                      class: "patch_grid_width_center_grey_line",
                    })
                    .css({
                      width: width + "px",
                      "border-left": "1px dashed rgba(0,0,0,1)",
                      "border-top": "1px dashed rgba(0, 0, 0, 0.5)",
                      "height:": height + "px",
                      "font-size": "12px",
                      "text-indent": "2px",
                      color: "rgba(0, 0, 0, 0.5)",
                    })
                    .appendTo(this.gridlines);
                } else {
                  $("<div>" + (z + 1) + "</div>")
                    .attr({
                      class: "patch_grid_grey_line",
                    })
                    .css({
                      width: width + "px",
                      "border-left": "1px dashed rgba(0, 0, 0, 0.5)",
                      "border-top": "1px dashed rgba(0, 0, 0, 0.5)",
                      "height:": height + "px",
                      "font-size": "12px",
                      "text-indent": "2px",
                      color: "rgba(0, 0, 0, 0.5)",
                    })
                    .appendTo(this.gridlines);
                }
              }
            } else {
              for (var z = 0; z < 16; z++) {
                if (z === 0) {
                  $("<div>" + (i + 1) + "</div>")
                    .attr({
                      class: "patch_grid_grey_line",
                    })
                    .css({
                      width: width + "px",
                      "border-left": "1px dashed rgba(0, 0, 0, 0.5)",
                      "border-top": "1px dashed rgba(0, 0, 0, 0.5)",
                      "height:": height + "px",
                      "font-size": "12px",
                      "text-indent": "2px",
                      color: "rgba(0, 0, 0, 0.5)",
                    })
                    .appendTo(this.gridlines);
                } else if (z === 8) {
                  $("<div></div>")
                    .attr({
                      class: "patch_grid_width_center_grey_line",
                    })
                    .css({
                      width: width + "px",
                      "border-left": "1px dashed rgba(0,0,0,1)",
                      "border-top": "1px dashed rgba(0, 0, 0, 0.5)",
                      "height:": height + "px",
                      "font-size": "12px",
                      "text-indent": "2px",
                    })
                    .appendTo(this.gridlines);
                } else {
                  $("<div></div>")
                    .attr({
                      class: "patch_grid_grey_line",
                    })
                    .css({
                      width: width + "px",
                      "border-left": "1px dashed rgba(0, 0, 0, 0.5)",
                      "border-top": "1px dashed rgba(0, 0, 0, 0.5)",
                      "height:": height + "px",
                      "font-size": "12px",
                      "text-indent": "2px",
                    })
                    .appendTo(this.gridlines);
                }
              }
            }
          }
          $("<div></div>")
            .attr({
              class: "patch_center_grid_grey_line",
            })
            .css({
              position: "absolute",
              "border-top": "1px dashed #000",
              height: "0px",
              top: 0,
              left: 0,
              width: this.clientWidth + "px",
              right: 0,
              bottom: 0,
              margin: "auto",
            })
            .appendTo(this.gridlines);
          break;
      }
    },
    toolMaskFs() {
      // 工具遮罩的尺寸改变
      this.toolMask.css({
        top: -this.TOOL.fixTop + "px",
        left: -this.TOOL.fixLeft + "px",
        width: this.TOOL.option.width + "px",
        height: this.TOOL.option.height + "px",
        "border-width": this.TOOL.fixTop + "px " + this.TOOL.fixLeft + "px",
      });
    },
    updateUserMsg(ev) {
      const vm = this;
      this.__ev = ev;
      this.$bus.emit("upDataUserMsg_vue");
      this.$bus.once("upDataUserMsg_vue_done", function hdr() {
        vm.showVoicePopup();
      });
    },
    showVoicePopup(ev) {
      let el = (ev || this.__ev).target;
      this.$bus.emit("stop_listen_BGM");
      // let x = this.TOOL.PfixLeft + (this.TOOL.clientWidth + 30 - 260);
      // let y = this.TOOL.PfixTop - 30;
      let rect = el.getBoundingClientRect();
      let x = rect.left - 55;
      let y = rect.top + rect.height + 12;
      this.$bus.emit("FeaturesPop_vue", {
        type: 1,
        name: "textToVoice",
        initialX: x,
        initialY: y,
        posx: x,
        posy: y,
      });
    },
    UndoRedo(type) {
      this.$bus.emit("undo_redo_vue", { type: type });
    },
    actionDraw() {
      // 启动auto-draw
      this.$bus.emit("materialPane_vue", { type: false });
      this.$bus.emit("FeaturesPop_close_vue", {
        type: 3,
      });
      this.TOOL.setOption({
        width: this.Tool_Size.width,
        height: this.Tool_Size.height - 40,
        scale: 1,
        surplusY: this.TopNav_Size.height + 40,
        surplusX: this.MaterialPane_Size.width,
      }).then(() => {
        this.$bus.emit("drawing_vue", { type: "draw" });
      });
    },
    onME(ev) {
      let el = ev.currentTarget;
      if (el.dataset["isOn"] == 1) {
        return;
      }
      if (el.classList.contains("disabled")) {
        el.style.backgroundColor = "#fafaff";
        return;
      }
      let iEl = el.querySelector("i");
      el.style.backgroundColor = "#9692A9";
      iEl.classList.add("active");
    },
    onML(ev) {
      let el = ev.currentTarget;
      if (el.dataset["isOn"] == 1) {
        return;
      }
      if (el.classList.contains("disabled")) {
        el.style.backgroundColor = "#fafaff";
        return;
      }
      let iEl = el.querySelector("i");
      el.style.backgroundColor = "#fafaff";
      iEl.classList.remove("active");
    },
    toggleSizeFs(data) {
      this.$modal.show("editorResizeTip", { data: data });
      // this.TOOL.setOptimized(data);
    },
    toggleLayerOptions(flag = true) {
      this.$refs.layerOptionsRef.toggle(flag);
    },
    onClickLayerBtn(ev) {
      let el = ev.currentTarget;
      let rect = el.getBoundingClientRect();
      let sprites = this.TOOL.selectedSprite;
      if (!sprites || (sprites && !sprites.length)) {
        this.$bus.emit("FeaturesPop_vue", {
          name: "sprites",
          posx: rect.left,
          posy: rect.bottom,
          type: 2,
        });
      }
    },
    delVip() {
      this.materialPushAnalysisTwo("delVipBtn");
      this.$bus.emit("Modal_vue", {
        name: "delVip",
        data: {
          type: "record",
        },
      });
    },
    openWordCloud() {
      this.$analysis("word_cloud,click_use，文字云_点击_使用");
      this.$store.commit("save_TopnavMsg", {
        isShowWordCloudDialog: true,
      });
    },
    openCameraSet() {
      let cameras = [];
      if (!this.lensEditState) {
        this.TOOL.selectSprite();
      }

      this.$store.commit("toggle_lensIndex", -1);
      this.$store.commit(
        "toggle_cameras",
        this.SelectScenes_Msg.camera.cameras
      );
      this.$store.commit("toggle_lensEditState", !this.lensEditState);
      this.$analysis(
        this.BaiduAnalysis[this.lensEditState ? "openLens" : "closeLens"]
      );
    },
    openSubtitleLayer() {
      // let toolElem = document.querySelector('#app > .Tool');
      // toolElem.style.display = 'none';
      this.$bus.emit("openSubtitleLayer");
      sensors.track('audioAndSubtitle', {
        version: ''
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#gridlines_tool_handle_box {
  position: relative;

  &:before {
    position: absolute;
    display: block;
    content: "";
    margin: -1px;
    box-sizing: content-box;
    pointer-events: none;
    top: 1px;
    bottom: 0;
    left: 1px;
    right: 0;
    z-index: 10;
    border-right: 1px solid rgba(255, 255, 255, 0.5);
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  }
  &:after {
    position: absolute;
    display: block;
    content: "";
    margin: -1px;
    box-sizing: content-box;
    pointer-events: none;
    top: 1px;
    bottom: 0;
    left: 1px;
    right: 0;
    border-right: 1px dashed rgba(0, 0, 0, 0.5);
    border-bottom: 1px dashed rgba(0, 0, 0, 0.5);
  }
}

.patch_grid_grey_line {
  position: relative;

  &:before {
    position: absolute;
    display: block;
    content: "";
    margin: -1px;
    box-sizing: content-box;
    pointer-events: none;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-left: 1px solid rgba(255, 255, 255, 0.5);
    border-top: 1px solid rgba(255, 255, 255, 0.5);
  }
}
.patch_grid_width_center_grey_line {
  position: relative;

  &:before {
    position: absolute;
    display: block;
    content: "";
    margin: -1px;
    box-sizing: content-box;
    pointer-events: none;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-left: 1px solid rgba(87, 120, 251, 0.5);
    border-top: 1px solid rgba(255, 255, 255, 0.5);
  }
}
.patch_center_grid_grey_line {
  position: relative;

  &:before {
    position: absolute;
    display: block;
    content: "";
    box-sizing: content-box;
    pointer-events: none;
    top: -1px;
    bottom: 0;
    left: 0;
    right: 0;
    border-top: 1px solid rgba(87, 120, 251, 0.5);
  }
}
</style>
<style scoped lang="scss">
.editorBtn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  height: 40px;
  padding: 3px 3px 3px 3px;
  position: absolute;
  top: -33px;
  left: 0;
  z-index: 130;
  // background-color: #e8ebf4;
  // background: linear-gradient(to bottom, #EFF1F8 40%, rgba(240, 240, 248, 0.7));

  & > .main {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    flex-shrink: 1;
  }
  & > .side {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;

    & > .btn-sound {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 112px;
      height: 34px;
      background: #fafaff;
      box-shadow: 0px 3px 6px rgba(197, 197, 197, 0.16);
      border: 1px solid #fafaff;
      border-radius: 4px;
      cursor: pointer;
      color: #474261;
      & > .iconfont {
        font-size: 16px;
        margin-right: 2px;
      }
      &:hover {
        color: #5778fb;
        border: 1px solid #5778fb;
      }
      & .msg {
        position: absolute;
        top: calc(100% + 9px);
        right: 0;
        width: 168px;
        height: 76px;
        border-radius: 4px;
        background-color: rgba(#000, 0.5);
        color: #fff;
        font-size: 12px;
        line-height: 1.4;
        text-align: left;
        padding: 12px;
      }
    }
  }

  .vipWarry {
    width: auto;
    height: 34px;
    padding-top: 7px;
    line-height: 1.5;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #ff0042;

    a {
      text-decoration: underline;
      font-size: 14px;
      font-weight: normal;
      letter-spacing: 0px;
      color: #ff0042;
      cursor: pointer;
    }
  }

  & > .main > div {
    // position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 44px;
    height: 34px;
    background: #fafaff;
    overflow: hidden;
    border-radius: 5px;
    box-shadow: #d8dee9 0px 0px 5px 0px;
    margin-right: 3px;
    cursor: pointer;
    &.layer {
      overflow: visible;
    }
  }
  & > .main > div:last-child {
    margin-right: 0;
  }
  & > .main > .toggleSize {
    position: relative;
    overflow: inherit;

    &:hover {
      .sizeBox {
        height: 100px;
        top: 30px;
        opacity: 1;
      }
    }

    .sizeType {
      > i {
        position: absolute;
        top: 0px;
        left: 10px;
        bottom: 0;
        margin: auto;
        width: 17px;
        height: 17px;
        > i {
          position: absolute;
          top: 0px;
          left: 0px;
          bottom: 0;
          right: 0;
          margin: auto;
          border: solid 2px #9692a9;
          border-radius: 2px;
          background-color: #9692a9;
        }
      }
      > font {
        position: absolute;
        top: 0px;
        bottom: 0;
        right: 10px;
        margin: auto;
        width: 30px;
        height: 18px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #474261;
      }
    }
    .sizeBox {
      position: absolute;
      width: 90px;
      height: 0px;
      top: -10px;
      opacity: 0;
      left: -6px;
      padding: 3px;
      padding-top: 20px;
      overflow: hidden;
      transition: all 0.3s;
      > div {
        background-color: #ffffff;
        border-radius: 4px;
        box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
        padding: 3px;
        width: 84px;
        height: 77px;
        position: relative;

        &:before {
          position: absolute;
          top: -18px;
          left: 0;
          right: 0;
          margin: 0 auto;
          content: "";
          width: 0;
          height: 0;
          border-width: 10px 8px;
          border-style: solid;
          border-color: rgba(0, 0, 0, 0) rgba(0, 0, 0, 0) #fff rgba(0, 0, 0, 0);
        }
        > div {
          position: relative;
          width: 78px;
          height: 34px;
          border-radius: 4px;
          margin-bottom: 3px;
          overflow: hidden;
          > div {
            position: relative;
            width: 78px;
            height: 34px;
            background-color: rgba(0, 0, 0, 0);
            transition: all 0.3s;

            &:hover {
              background-color: #d4d4e7;
            }
          }
        }
      }
    }
  }

  .undo,
  .redo {
    &.disabled {
      background-color: #fafaff !important;
    }
  }

  .layer {
    position: relative;
    overflow: visible;
  }
  .adsorb {
    position: relative;
    overflow: inherit;
    // &:before {
    //   content: "NEW";
    //   width: 26px;
    //   height: 13px;
    //   background-color: #ffa200;
    //   border-radius: 3px;
    //   position: absolute;
    //   top: -3px;
    //   right: -3px;
    //   font-family: MicrosoftYaHei;
    //   font-size: 10px;
    //   font-weight: normal;
    //   font-stretch: normal;
    //   letter-spacing: -0.6px;
    //   color: #fefeff;
    //   font-style: initial;
    //   text-align: center;
    //   line-height: 13px;
    //   text-indent: initial;
    //   z-index: 10;
    // }
  }
}
@media (max-width: 1390px) {
  .editorBtn {
    flex-wrap: wrap;
    & > .side {
      justify-content: flex-start;
    }
    & > .side > .btn-sound {
      margin-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tool/editorBtn.vue